<template>
    <div>
        <div class="imgs">
            <div v-for="item in descImageList" :key="item.imageId">
                <img v-lazy="item.filePath" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['descImageList']
}
</script>
<style lang="scss" scoped>
.imgs {
    width: 1080px;
    border: 1px solid #ccc;
    text-align: center;
    padding-bottom: 80px;
    img:nth-child(1) {
        margin-top: 50px;
    }
    img[lazy="loading"] {
        display: block;
        width: 100px;
        height: 100px;
        margin: 0 auto;
    }
    img[lazy="loaded"] {
        width: 90%;
    }

}
</style>